module.exports = __webpack_public_path__ + "static/media/faviconProd.fa8adfe8.ico";